<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title heading-color">VIEW APPOINTMENT</h5>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <form [formGroup]="appointmentForm">
          <div class="card-body">
            <!--SEARCH APPOINTMENT DATE-->
            <div class="row">
              <div class="col-12">
                <h6 class="text-center">SELECT APPOINTMENT DATE</h6>
              </div>
            </div>
            <br />

            <div class="row mx-auto">
              <div class="col-lg-3 col-md-3"></div>

              <div class="col d-flex">
                <input
                  class="form-control"
                  placeholder="From Date(DD/MM/YYYY)"
                  name="fromDate"
                  ngbDatepicker
                  #fromDate="ngbDatepicker"
                  data-date-inline-picker="true"
                  id="fromDate"
                  formControlName="fromDate"
                />
                <div class="input-group-append">
                  <button
                    class="input-group-text btn btn-outline-secondary button-height calendar rounded-0"
                    (click)="fromDate.toggle()"
                    type="button"
                    id="fromDate"
                  >
                    <span class="fa fa-calendar"></span>
                  </button>
                </div>
              </div>
              <br />

              <div class="col d-flex ml-2">
                <input
                  class="form-control"
                  placeholder="To Date(DD/MM/YYYY)"
                  name="toDate"
                  ngbDatepicker
                  #toDate="ngbDatepicker"
                  data-date-inline-picker="true"
                  id="toDate"
                  [minDate]="minDate"
                  formControlName="toDate"
                />
                <div class="input-group-append">
                  <button
                    class="input-group-text btn btn-outline-secondary button-height calendar rounded-0"
                    (click)="toDate.toggle()"
                    type="button"
                    id="toDate"
                  >
                    <span class="fa fa-calendar"></span>
                  </button>
                </div>
              </div>

              <div class="col-lg-3 col-md-3"></div>
            </div>
            <br /><br />
            <div class="row">
              <div class="col-12 text-center">
                <button
                  type="submit"
                  name="find"
                  class="btn btn-primary text-white btn-rounded"
                  (click)="findAppointments()"
                  [disabled]="!appointmentForm.valid"
                >
                  FIND APPOINTMENT
                </button>
              </div>
              <!-- download excel -->
              <div
                class="d-flex"
                *ngIf="appointmentData && appointmentData.length > 0"
              >
                <div class="pl-0 pr-0 align-items-center pull-right mt-3 ml-5">
                  <p class="font-weight-100">
                    <button (click)="exportAsXLSX()">
                      <i
                        class="fa fa-file-excel-o mr-1"
                        style="font-size: 23px; color: blue"
                      ></i>
                    </button>
                  </p>
                </div>
                <div class="pl-0 pr-0 ml-2 pull-right mt-4">
                  <label class="font-weight-bold">Click Icon to Download</label>
                </div>
              </div>
              <!-- download excel -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- table -->
<div class="container-fluid" *ngIf="appointmentData?.length">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body table-responsive">
          <div class="col-md-12 detail-tbl">
            <table class="table">
              <thead>
                <tr>
                  <th
                    scope="col"
                    class="th-item"
                    style="vertical-align: middle"
                  >
                    Appt ID
                  </th>
                  <th
                    scope=" col"
                    class="th-item"
                    style="vertical-align: middle"
                  >
                    Appt Date
                  </th>
                  <th
                    scope="col"
                    class="th-item"
                    style="vertical-align: middle"
                  >
                    Appt Time
                  </th>
                  <th
                    scope="col"
                    class="th-item"
                    style="vertical-align: middle"
                  >
                    Physician Name
                  </th>
                  <th
                    scope="col"
                    class="th-item"
                    style="vertical-align: middle"
                  >
                    Phy. Contact No
                  </th>
                  <th
                    scope="col"
                    class="th-item"
                    style="vertical-align: middle"
                  >
                    Patient Name
                  </th>
                  <th
                    scope="col"
                    class="th-item"
                    style="vertical-align: middle"
                  >
                    Pat. Contact No
                  </th>
                  <th
                    scope="col"
                    class="th-item"
                    style="vertical-align: middle"
                  >
                    Appt Type
                  </th>
                  <th
                    scope="col"
                    class="th-item"
                    style="vertical-align: middle"
                  >
                    Status
                  </th>
                </tr>
              </thead>
              <tr *ngFor="let a of appointmentData; let i = index">
                <td class="font-size-15 text-color align-middle">
                  {{ a.aptid === null ? "Not Available" : a.aptid }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{
                    a.apdate === null
                      ? "Not Available"
                      : (a.apdate | date: "dd-MMM-yyyy")
                  }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ a.aptime === null ? "Not Available" : a.aptime }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ a?.physician_firstname || "Not Available" }}
                  {{ a?.physician_lastname || "Not Available" }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ a?.physician_contactno || "Not Available" }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ a?.patient_firstname || "Not Available" }}
                  {{ a?.patient_lastname || "Not Available" }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ a?.patient_contactno || "Not Available" }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ a?.apttype || "Not Available" }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ a?.schedule_stat || "Not Available" }}
                </td>
              </tr>
              <tbody>
                <tr></tr>
              </tbody>
            </table>
          </div>
          <!-- <div class="row">
            <div class="col-md-12 mt-2">
              <div class="d-flex">
                <div class="form-group d-flex mb-0 mr-2">
                  <select
                    class="form-control"
                    [(ngModel)]="pagesize"
                    id="pagesize"
                    (change)="pageChanged()"
                  >
                    <option *ngFor="let c of pageCount" value="{{ c }}">
                      {{ c }}
                    </option>
                  </select>
                </div>
                <ngb-pagination
                  [collectionSize]="collectionSize"
                  [(page)]="page"
                  [maxSize]="5"
                  [pageSize]="pagesize"
                  [rotate]="true"
                  [boundaryLinks]="true"
                  (pageChange)="pageChanged()"
                ></ngb-pagination>
                <div class="ml-2 line-h-36">
                  Total rows : {{ collectionSize }}
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
<!-- table end -->

<div class="container-fluid" *ngIf="noAppointment">
  <div class="card m-b-30">
    <div class="card-body table-responsive">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h5 class="text-danger">No Appointment Found</h5>
        </div>
      </div>
    </div>
  </div>
</div>
